<div class="external-appointment-page">
  <div class="external-header">
    <h1 class="page-title">
      <i class="fas fa-calendar-alt me-2"></i>
      Agendamento Externo
    </h1>
    <p class="text-muted">Preencha as informações abaixo e selecione o dia e horário desejados.</p>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
    <p class="mt-3 text-muted">Carregando informações...</p>
  </div>

  <div *ngIf="!isLoading && error" class="alert alert-danger m-4">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
  </div>

  <div *ngIf="!isLoading && !error" class="external-content">
    <!-- Bloco: Dados do Prestador -->
    <div class="card section-card">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-building me-2"></i>Dados do Prestador</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nome / Razão Social</label>
            <input type="text" class="form-control" [value]="providerName" readonly>
          </div>
          <div class="col-md-3">
            <label class="form-label">CNPJ</label>
            <input type="text" class="form-control" [value]="providerCnpj" readonly>
          </div>
          <div class="col-md-3">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" [value]="providerPhone" readonly>
          </div>
        </div>

        <div class="row g-3 mt-1">
          <div class="col-md-12">
            <label for="serviceDescription" class="form-label">
              Serviço a ser Realizado <span class="text-danger">*</span>
            </label>
            <textarea id="serviceDescription" class="form-control" rows="2"
              [(ngModel)]="serviceDescription"
              placeholder="Descreva o serviço a ser realizado"></textarea>
          </div>
          <div class="col-md-12">
            <label for="serviceAddress" class="form-label">
              Endereço do Serviço <span class="text-danger">*</span>
            </label>
            <textarea id="serviceAddress" class="form-control" rows="2"
              [(ngModel)]="serviceAddress"
              placeholder="Informe o endereço completo onde o serviço será realizado"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Bloco: Informações do Condutor -->
    <div class="card section-card">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-user me-2"></i>Informações do Condutor</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label for="driverName" class="form-label">Nome do Condutor <span class="text-danger">*</span></label>
            <input type="text" id="driverName" class="form-control" [(ngModel)]="driver.name">
          </div>
          <div class="col-md-3">
            <label for="driverCpf" class="form-label">CPF <span class="text-danger">*</span></label>
            <input type="text" id="driverCpf" class="form-control" [(ngModel)]="driver.cpf">
          </div>
          <div class="col-md-3">
            <label for="vehiclePlate" class="form-label">Placa do Veículo <span class="text-danger">*</span></label>
            <input type="text" id="vehiclePlate" class="form-control" [(ngModel)]="driver.vehiclePlate">
          </div>
          <div class="col-md-12">
            <label for="companyName" class="form-label">Empresa</label>
            <input type="text" id="companyName" class="form-control" [(ngModel)]="driver.company">
          </div>
        </div>
      </div>
    </div>

    <!-- Bloco: Dia e Horário -->
    <div class="card section-card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0"><i class="fas fa-calendar-day me-2"></i>Escolha o Dia e Horário</h5>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-light btn-sm" (click)="prevMonth()">
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="fw-semibold">{{ getMonthName(viewMonth) }} {{ viewYear }}</span>
          <button type="button" class="btn btn-light btn-sm" (click)="nextMonth()">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="calendar-grid">
          <div *ngFor="let day of previewDays"
            class="calendar-day"
            [class.disabled]="!day.available"
            [class.selected]="day === selectedPreviewDay"
            (click)="selectPreviewDay(day)">
            <div class="day-name">{{ day.dayName }}</div>
            <div class="day-number">{{ day.dayNumber }}</div>
          </div>
        </div>

        <div *ngIf="selectedPreviewDay" class="time-slots-section mt-4">
          <h6 class="fw-semibold mb-3">
            Horários disponíveis para
            {{ selectedPreviewDay.fullDate | date: 'dd/MM/yyyy' }}
          </h6>
          <div class="time-slots-grid">
            <button type="button" class="time-slot-btn"
              *ngFor="let slot of selectedPreviewDay.timeSlots"
              [class.selected]="slot === selectedTimeSlot"
              (click)="chooseTimeSlot(slot)">
              {{ slot.start }} - {{ slot.end }}
            </button>
          </div>
          <div *ngIf="!selectedPreviewDay.timeSlots.length" class="text-muted small mt-2">
            Nenhum horário disponível para este dia.
          </div>
        </div>

        <div *ngIf="!selectedPreviewDay" class="text-muted small mt-3">
          <i class="fas fa-info-circle me-1"></i>
          Selecione um dia para visualizar os horários disponíveis.
        </div>
      </div>
    </div>

    <!-- Resumo + Submit -->
    <div class="card section-card summary-card" *ngIf="selectedPreviewDay && selectedTimeSlot">
      <div class="card-body d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div>
          <div class="text-muted small">Resumo</div>
          <div class="fw-semibold">
            {{ selectedPreviewDay.fullDate | date: 'dd/MM/yyyy' }} —
            {{ selectedTimeSlot.start }} às {{ selectedTimeSlot.end }}
          </div>
        </div>
        <button class="btn btn-primary btn-lg" (click)="submitAppointment()">
          <i class="fas fa-check me-2"></i>
          Confirmar Agendamento
        </button>
      </div>
    </div>

    <div class="footer text-center" *ngIf="!(selectedPreviewDay && selectedTimeSlot)">
      <button class="btn btn-primary btn-lg" (click)="submitAppointment()">
        <i class="fas fa-check me-2"></i>
        Confirmar Agendamento
      </button>
    </div>
  </div>
</div>
